<template lang="pug">
  div
</template>

<script>

  import { mapActions, mapState, mapGetters } from "vuex";
  import { getEmailCaptureModalCookieExists } from "@components/EmailCapture/utils";

  export default {
    name: 'PostColorAdvisorEmailCapture',
    data() {
      return {
        experimentName: 'Post CA Email Capture Test 2023',
      };
    },
    computed: {
      ...mapState('customer', ['cdata']),
      ...mapGetters('emailCapture', [
        'colorAdvisorModalConfig'
      ]),
      isPostCAEmailCaptureEnabled() {
        return this.experiments[this.experimentName] && this.experiments[this.experimentName] === 'B';
      },
      canShowEmailCapture() {
        return Boolean(
          this.isPostCAEmailCaptureEnabled &&
            !this.cdata.email &&
            !getEmailCaptureModalCookieExists() &&
            this.$route.query['color-advisor']
        );
      }
    },
    methods: {
      ...mapActions('emailCapture', ['manualCloseEmailModal']),
    },
    mounted() {
      if (this.experiments[this.experimentName]) {
        this.mix_trackExperimentViewed(this.experimentName);
        if (this.canShowEmailCapture) {
          this.showModal({
            component: './EmailCapture/ColorAdvisorEmailCaptureModal',
            theme: 'full-screen blur'
          });
        }
      }
    }
  };
</script>
